import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { isObject } from '@open-tender/utils'
import {
  authCustomerThanx,
  selectBrand,
  selectCanOrder,
  selectCartQuantity,
  selectCartTotal,
  selectCustomer,
  selectMenuSlug,
  selectOrderLimits,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  Content,
  HeaderDefault,
  Main,
  PageTitle,
  PageContainer,
  PageContent,
  Loading,
  Message,
} from 'components'

const Thanx = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { title: siteTitle } = useAppSelector(selectBrand) || {}
  const { auth, loading, error } = useAppSelector(selectCustomer)
  const menuSlug = useAppSelector(selectMenuSlug)
  const cartCount = useAppSelector(selectCartQuantity)
  const cartTotal = useAppSelector(selectCartTotal)
  const { orderMinimum, orderMaximum } = useAppSelector(selectOrderLimits)
  const canOrder = useAppSelector(selectCanOrder)
  const belowMinimum = orderMinimum && cartTotal < orderMinimum
  const aboveMaximum = orderMaximum && cartTotal > orderMaximum
  const canCheckout =
    canOrder && cartCount !== 0 && !belowMinimum && !aboveMaximum
  const canMenu = canOrder && cartCount !== 0 && menuSlug
  const redirect = canCheckout ? '/checkout' : canMenu ? menuSlug : '/account'
  const isLoading = loading === 'pending'
  const errMsg = error
    ? isObject(error)
      ? (error as any).detail || (error as any).message
      : error
    : null
  const title = errMsg ? 'Something went wrong' : 'Retrieving your account'
  const subtitle = errMsg
    ? 'Please review the error below and retry your request or contact support'
    : 'Please hang tight. This will only take a second.'
  const query = new URLSearchParams(useLocation().search)
  const code = query.get('code')

  useEffect(() => {
    if (auth) {
      navigate(redirect)
    } else if (code) {
      dispatch(authCustomerThanx({ code, origin: null, path: null }))
    } else {
      navigate('/account')
    }
  }, [auth, code, redirect, navigate, dispatch])

  return (
    <>
      <Helmet>
        <title>Thanx | {siteTitle}</title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle title={title} subtitle={subtitle} />
            <PageContent>
              {isLoading ? (
                <Loading text="Contacting Thanx..." />
              ) : errMsg ? (
                <Message color="error" style={{ width: '100%' }}>
                  {errMsg}
                </Message>
              ) : null}
            </PageContent>
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default Thanx
